<template>
    <div class="auth-page container">
        
<FormKitLazyProvider config-file="true" :default-config="false">
<CatalogBreadcrumbs :navLinks="Bread" />
        <div class="auth-container content-container content-container_bg-primary">
            <div class="auth-container-left">
                <h1 class="title_container">{{ $t('registration.title') }}</h1>
                <FormKit type="form" autocomplete="off" :actions="false" @submit="onSubmit" :incomplete-message="false" #="{ state, value }">
                    <div class="auth-form">
                        <FormKit type="text" name="name" :label="$t('registration.name_label')" :placeholder="$t('registration.name_placeholder')" validation="required|length:2" />
                        <FormKit 
                            type="text" 
                            name="email"
                            autocomplete="off" 
                            :label="$t('auth.email_label')" 
                            :placeholder="$t('auth.email_placeholder')" 
                            validation="required:trim|email|emailValidation"
                            :validation-rules="{ emailValidation }"
                            :validation-visibility="'dirty'"
                            :validation-messages="{ emailValidation: t('auth.email_already_exists') }"
                        />
                        <FormkitPassword name="password" :label="$t('auth.password_label')" validation="required|length:8" :placeholder="$t('auth.password_placeholder')" />
                        <FormkitPassword name="password_confirmation" :label="$t('registration.password_confirmation_label')" validation="required|length:8|confirm:password" :placeholder="$t('registration.password_confirmation_placeholder')" :validation-messages="{
                            confirm: $t('forms.passwords_not_match')
                        }" />
                        <RecaptchaCustom id="captcha-registration" v-if="isCaptchaEnabled" />
                    </div>
                    <div class="checkbox-container">
                        <FormKit name="checkbox_1" type="checkbox">
                            <template #label="{ id, classes }">
                                <label :for="id" :class="classes.label">{{ $t('interface.i_agree') }} <a :href="`/${locale}/terms-of-use.pdf`" target="_blank">{{ $t('forms.checkbox.terms_of_use') }}</a></label>
                            </template>
                        </FormKit>
                        <FormKit name="checkbox_2" type="checkbox">
                            <template #label="{ id, classes }">
                                <label :for="id" :class="classes.label">{{ $t('interface.i_agree') }} <a :href="`/${locale}/privacy-cookie-policy.pdf`" target="_blank">{{ $t('forms.checkbox.privacy_cookie_policy') }}</a></label>
                            </template>
                        </FormKit>
                        <!-- Пока скрыто согласно задаче. KILLME через месяц - 27.02.2025 -->
                        <!-- <FormKit name="checkbox_3" type="checkbox">
                            <template #label="{ id, classes }">
                                <label :for="id" :class="classes.label">{{ $t('interface.i_agree') }} <a  :href="`${locale === 'en' ? '/rules`' : `/${locale}`}/rules`" target="_blank">{{ $t('forms.checkbox.rules_of_service') }}</a></label>
                            </template>
                        </FormKit> -->
                    </div>
                    <button class="btn btn-secondary" :class="{ 'btn-loaded': state.loading }" :disabled="!value?.checkbox_1 || !value?.checkbox_2 || state.loading" type="submit">{{ $t('registration.button_label') }}</button>
                </FormKit>
            </div>
            <div class="auth-container-right">
                <img src="/assets/images/png/auth/registration.png" alt="auth-image" />
            </div>
        </div>
        <div class="auth-container-bottom-box">
            <NuxtLinkLocale to="/auth" class="auth-container-bottom auth-container-bottom-link content-container content-container_bg-secondary">
                <p class="text">
					{{ $t('registration.have_account') }} 
					<span class="link">{{ $t('auth.title') }}</span>
                </p>
            </NuxtLinkLocale>
        </div>
        <div class="content-container auth-container-bottom email-hint" v-if="isEmailHintShow">
            <AuthGoToEmail :text="$t('registration.email_hing')" />
        </div>
</FormKitLazyProvider>

    </div>
</template>

<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import { useUserAuth } from '@/composables/user/UseUserAuth'
import type { UserRegisterRequestType } from '@/composables/user/types/UserTypes'
import { formatErrorMessages } from '~/assets/functions';
import { useI18n } from 'vue-i18n'
import { useMeta } from '~/composables/meta/useMeta';

const { $recaptcha, $toast } = useNuxtApp()
const isCaptchaEnabled = useRuntimeConfig().public.isCaptchaEnabled

const RecaptchaCustom = defineAsyncComponent(() => import('~/components/common/RecaptchaCustom.vue'));

const { t, locale } = useI18n()
const { setSEOTitles } = seoHandlers()
const { getMetaByUrl } = useMeta();
const { data: meta } = await useAsyncData('registrationMeta', () => getMetaByUrl('registration'))
if (meta.value) {
    setSEOTitles({
        seoTitle: meta.value?.seo_meta_data?.seo_title || '',
        seoDescription: meta.value?.seo_meta_data?.seo_description || '',
        seoKeywords: meta.value?.seo_meta_data?.seo_keywords || ''
    })
}
const Bread = [
    {
        name: t('interface.home'),
        link: '/',
    },
    {
        name: t('registration.title'),
        link: '/registration',
    }
]

const localPath = useLocalePath()

const isEmailHintShow = ref(false)

const { userRegistration, userLogin, getUserMe, checkIfEmailExists } = useUserAuth()

const emailValid = ref(false)

const emailValidation = async (node: FormKitNode) => {
    if (!node?.value) return false
    const exists = await checkIfEmailExists(String(node.value))
    emailValid.value = !exists
    return emailValid.value
}



const onSubmit = async (form: UserRegisterRequestType) => {
    let token = null
    if (isCaptchaEnabled) {
        token = await $recaptcha.getResponse().catch((err: string) => { console.error(err); });
    }
    if (!token && isCaptchaEnabled) {
        $toast.error(t('forms.captcha_error'))
        return
    }
    await userRegistration({ ...form, 'g-recaptcha-response': token }).then(() => {
        $toast.success(t('forms.success'))
        userLogin({password: form.password, email: form.email}).then(() => {
            getUserMe().then(() => {
                navigateTo(localPath('/profile'))
            })
        })
    }).catch((err) => {
        $toast.error(formatErrorMessages(err))
    });
}

</script>

<style lang="scss" scoped>
.checkbox-container {
    display: flex;
    margin: 20px 0 12px;
    flex-direction: column;
    gap: 12px;
    width: 200%;
}

.email-hint {
    background-color: rgba(94, 235, 82, 0.1);
}

.auth-container-right img {
    width: 239px;
    height: 288px;
    filter: drop-shadow(0 8px 17px rgba(218, 71, 39, 0.2)) drop-shadow(0 32px 32px rgba(218, 71, 39, 0.17)) drop-shadow(0 71px 43px rgba(218, 71, 39, 0.1)) drop-shadow(0 127px 51px rgba(218, 71, 39, 0.03)) drop-shadow(0 198px 55px rgba(218, 71, 39, 0));
    align-self: flex-start;
    margin-top: 38px;
}

.checkbox-link {
    text-decoration: underline;
}

@media (max-width:1023px) {
    .checkbox-container {
        margin: 18px 0 12px;
        gap: 12px;
        width: 100%;

        :deep(.formkit-outer[data-type=checkbox]) {
        
            .formkit-label {
                font-size: 12px;
            }
        }

    }

    .auth-container-right img {
        width: 81px;
        height: 97px;
        filter: drop-shadow(0 2px 4px rgba(218, 71, 39, 0.2)) drop-shadow(0 7px 7px rgba(218, 71, 39, 0.17)) drop-shadow(0 17px 10px rgba(218, 71, 39, 0.1)) drop-shadow(0 30px 12px rgba(218, 71, 39, 0.03)) drop-shadow(0 47px 13px rgba(218, 71, 39, 0));
        margin-top: 0;
    }

    .auth-container-bottom {
        &>.text {
            max-width: 180px;
        }
    }

}
</style>